const entrypoints = {
  default: {
    entry: () => import(/* webpackChunkName: "theme-default" */ '@/themes/default/theme.js')
  },
  customs: [
    {
      hostname: 'ponte-pix-xpto.bemobi.com',
      entry: () => import(/* webpackChunkName: "theme-xpto" */ '@/themes/xpto/theme.js')
    },
    {
      hostname: 'ponte-pix-claro-controle.bemobi.com',
      entry: () => import(/* webpackChunkName: "theme-claro-controle" */ '@/themes/claro-controle/theme.js')
    },
    {
      hostname: 'ponte-pix-claro-recarga.bemobi.com',
      entry: () => import(/* webpackChunkName: "theme-claro-recarga" */ '@/themes/claro-recarga/theme.js')
    },
    {
      hostname: 'ponte-pix-vivo-recarga.bemobi.com',
      entry: () => import(/* webpackChunkName: "theme-vivo-recarga" */ '@/themes/vivo-recarga/theme.js')
    },
    {
      hostname: 'ponte-pix-oi-controle.bemobi.com',
      entry: () => import(/* webpackChunkName: "theme-oi-controle" */ '@/themes/oi-controle/theme.js')
    },
    {
      hostname: 'ponte-pix-tim-controle.bemobi.com',
      entry: () => import(/* webpackChunkName: "theme-tim-controle" */ '@/themes/tim-controle/theme.js')
    },
    {
      hostname: 'ponte-pix-claro-flex.bemobi.com',
      entry: () => import(/* webpackChunkName: "theme-claro-flex" */ '@/themes/claro-flex/theme.js')
    }
  ]
}

export { entrypoints }
